// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__d1+9q","page-item":"style_page-item__QX9V1","page-link":"style_page-link__GWOf0","active_pagination":"style_active_pagination__Fu032"};